import { Injectable } from '@angular/core';
import { ResetPassword } from 'src/app/models/User/ResetPassword.model';
import { ApiErrorResponse, ApiService, ApiSuccessResponse } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  constructor(private api: ApiService) { }

  async sendResetPasswordEmail(email: string): Promise<ApiErrorResponse | ApiSuccessResponse<string>> {
    const r: ApiErrorResponse | ApiSuccessResponse<string> = await this.api.post(`/forgot-password`, { Email: email });

    if (!r.success) {
      throw (r)
    }

    return r;
  }

  async resetPassword(redefine: ResetPassword) {
    const r: ApiErrorResponse | ApiSuccessResponse<string> = await this.api.post(`/forgot-password/reset`, redefine);

    if (!r.success) {
      throw (r);
    }

    return r;
  }
}
